var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let GrabitDialog = class GrabitDialog extends LitElement {
    constructor() {
        super(...arguments);
        this.open = false;
    }
    static { this.styles = css `
    :host {
      display: block;
    }

    .dialog-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s, visibility 0s 0.3s;
    }

    :host([open]) .dialog-container {
      opacity: 1;
      visibility: visible;
      transition: opacity 0.3s;
    }

    .backdrop {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      cursor: pointer;
    }

    .dialog {
      position: relative;
      background: white;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      padding: 10px;
      display: flex;
      flex-direction: column;
      transform: translateY(20px);
      transition: transform 0.3s;
      overflow: hidden;
    }

    :host([open]) .dialog {
      transform: translateY(0);
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;
    }

    .dialog-title {
      flex-grow: 1;
    }

    .close-button {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 18px;
      padding: 4px;
    }

    .dialog-content {
      display: flex;
      overflow-y: auto;
      flex-grow: 1;
      margin-top: 6px;
    }
  `; }
    connectedCallback() {
        super.connectedCallback();
        if (this.open) {
            this._disableBodyScroll();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.open) {
            this._enableBodyScroll();
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('open')) {
            if (this.open) {
                this._disableBodyScroll();
            }
            else {
                this._enableBodyScroll();
            }
        }
    }
    _disableBodyScroll() {
        document.body.style.overflow = 'hidden';
    }
    _enableBodyScroll() {
        document.body.style.overflow = '';
    }
    openDialog() {
        this.open = true;
    }
    closeDialog() {
        this.open = false;
        // this.dispatchEvent(new CustomEvent('grabit-dialog-close'));
    }
    render() {
        return html `
      <div class="dialog-container">
        <div class="backdrop" @click="${this.closeDialog}"></div>
        <div class="dialog">
          <div class="dialog-header">
            <div class="dialog-title">
              <slot name="title"></slot>
            </div>
            <button class="close-button" @click="${this.closeDialog}">X</button>
          </div>
          <div class="dialog-content">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: Boolean, reflect: true })
], GrabitDialog.prototype, "open", void 0);
GrabitDialog = __decorate([
    customElement('grabit-dialog')
], GrabitDialog);
export { GrabitDialog };
